import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, PropType } from "vue";
import { storeToRefs } from "pinia";

import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'RoleGuard',
  props: {
  roles: {
    type: Array as PropType<String[]>,
    required: false,
  },
  notRoles: {
    type: Array as PropType<String[]>,
    default: () => [],
    required: false,
  },
},
  setup(__props) {

const props = __props;



const { user: currentUser } = storeToRefs(useUserStore());

const checkUserHasRole = computed(() => {
  if (props.roles && props.roles.length > 0) {
    return userHasRole(currentUser.value.roles, props.roles);
  }

  if (props.notRoles && props.notRoles.length > 0) {
    return !userHasRole(currentUser.value.roles, props.notRoles);
  }

  return false;
});

return (_ctx: any,_cache: any) => {
  return (_unref(checkUserHasRole))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ]))
    : _createCommentVNode("", true)
}
}

})